import React from "react";
import { FiTrash2 } from "react-icons/fi";
import EditCashModal from "../modals/edit_cash";
import DeleteObjectModal from "../modals/delete_object";

export function canModifyCashTransactions() {
  const role = localStorage.getItem("role");
  if (!role) return true;
  return role !== "C";
}

const deleteButtonStyle = {
  padding: "5px 8px",
  border: "1px solid #c0392b",
  borderRadius: 6,
  background: "#fdf2f2",
  color: "#922b21",
  cursor: "pointer",
  display: "inline-flex",
  alignItems: "center",
  lineHeight: 1,
};

export default function CashTransactionActions({
  cash,
  refreshData,
  projectOptions,
  lockProject = false,
  lockConsultant = false,
}) {
  if (!cash?.cash_id || !canModifyCashTransactions()) return null;

  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 6, marginLeft: "auto" }}>
      <EditCashModal
        cash={cash}
        refreshData={refreshData}
        projectOptions={projectOptions}
        lockProject={lockProject}
        lockConsultant={lockConsultant}
      />
      <DeleteObjectModal
        objectType="Cash"
        objectId={cash.cash_id}
        objectName={cash.cash_id}
        onObjectDeleted={refreshData}
        trigger={
          <button type="button" title="Delete transaction" aria-label="Delete transaction" style={deleteButtonStyle}>
            <FiTrash2 size={16} />
          </button>
        }
      />
    </span>
  );
}
